export const shopSignStatusDic: Record<string, any> = {
  "0": "未网签",
  "1": "已网签",
  "2": "网签失败",
  //   "3": "网签中",
  //   "4": "待审核",
  //   "5": "审核驳回",
};
export const chainBizType: Record<string, any> = {
  "1": "订单收益",
  "2": "订单售后",
  "3": "返利充值",
  "4": "活动充值",
};
// 充值管理
export const chargeManaAccountTypeDic: Record<string, any> = {
  "1": "门店",
  "2": "达人",
};
export const chargeManaEarningTypeDic: Record<string, any> = {
  "1": "返利收益",
  "2": "活动收益",
};
export const chargeManaTradeTypeDic: Record<string, any> = {
  "1": "增加收益",
  "2": "扣减收益",
};
export const chargeManaStatusTypeDic: Record<string, any> = {
  "1": "待审核",
  "2": "已审核",
  "3": "已作废",
};
export const salesManTypeList: Record<string, any> = {
  "-1": "全部",
  1: "公司",
  2: "个人",
};

export const goodsScoreList: Record<string, any> = {
  1: "1星",
  2: "2星",
  3: "3星",
  4: "4星",
  5: "5星",
};
export const orderRevenueBankType: Record<string, any> = {
  1: "对公",
  2: "对私",
  3: "对公",
};
export const orderRevenueBusiness1Type: Record<string, any> = {
  1: "订单收入",
  2: "订单售后",
  //   3: "提现",
  3: "充值导入",
};
export const orderRevenueBusinessType: Record<string, any> = {
  1: "订单收入",
  2: "售后扣减",
  3: "提现",
  4: "提现回滚",
  5: "已发货售后冻结",
  6: "已发货售后冻结还原",
  7: "充值导入",
};
export const orderRevenueBusinessTypeReduce: Record<string, any> = {
  1: "订单收入",
  2: "售后扣减",
  3: "提现",
  4: "提现回滚",

  7: "充值导入",
};
export const orderRevenueCate: Record<string, any> = {
  1: "上级销售收益",
  2: "一级销售收益",
  3: "常规返利",
  4: "权益金",
  5: "活动收益",
};

export const orderRevenueStatus: Record<string, any> = {
  0: "待入账",
  1: "已入账",
  2: "已取消",
};
export const orderRevenueLinkTypeName: Record<string, any> = {
  门店: "门店",
  达人: "达人",
  店员: "店员",
  推广人: "推广人",
  连锁: "连锁",
};
export const priceModeOfBatch: Record<string, any> = {
  0: "不变",
  1: "涨价",
  2: "降价",
};
export const updatePriceType: Record<string, any> = {
  1: "批量导入批次规格价格",
  2: "批量导入规格价格",
  3: "批量设置加价规则",
};
export const updatePriceStatus: Record<string, any> = {
  0: "审核拒绝",
  1: "审核通过",
  2: "待审核",
};
export const skuViewBatchStatus: Record<string, any> = {
  //   "-1": "全部",
  //   状态：1-中台上架，0-中台下架，-1-未设置价格,2-价格变更下架,-3 手动下架

  1: "中台上架",
  0: "中台下架",
  "-1": "未设置价格",
  2: "价格变更下架",
  3: "手动下架",
};
export const goodsSoldOutNotifyUserType: Record<string, any> = {
  //   "-1": "全部",
  1: "门店",
  2: "员工",
  3: "推广人",
  4: "消费者",
  5: "达人",
};
export const goodsSoldOutNotifyStatus: Record<string, any> = {
  //   "-1": "全部",
  1: "已通知",
  0: "未通知",
};
export const couponRedeemAccessType: Record<string, any> = {
  //   "-1": "全部",
  1: "门店",
  2: "消费者",
};
export const couponPushChannel: Record<string, any> = {
  //   "-1": "全部",
  1: "门店",
  2: "会员",
  3: "代客下单",
};
export const couponGrantMember: Record<string, any> = {
  //   "-1": "全部",
  1: "全部会员",
  2: "指定会员",
  3: "新注册会员",
};
export const couponGrantShop: Record<string, any> = {
  //   "-1": "全部",
  1: "全部门店",
  2: "指定门店可用",
  3: "新注册门店",
};
//
export const skuBatchSpecAlertDic: Record<string, any> = {
  "-1": "未设置价格",
  0: "下架",
  1: "上架",
  2: "价格变更下架",
  //   "-3": "手动下架",
};
// 基础状态
export const batchSpecDicList: Record<string, any> = {
  // "-1": "未设置价格",
  0: "下架",
  1: "上架",
  //   2: "价格变更下架",
  //   "-3": "手动下架",
};
export const rebateRuleTypeList: Record<string, any> = {
  "-1": "全部",
  1: "全部门店",
  2: "指定门店",
  3: "指定省份",
  //   4: "指定服务站",
  5: "指定活动",
  6: "标签门店",
};
export const baseStatusList: Record<string, any> = {
  "-1": "全部",
  1: "启用",
  0: "禁用",
};
export const chainCateList: Record<string, any> = {
  "-1": "全部",
  1: "普通连锁",
  2: "RKA",
};
export const goodsControlApplyStatusList: Record<string, any> = {
  "-100": "全部",
  "-2": "已作废",
  1: "审核通过",
  0: "审核拒绝",
  2: "待审核",
};
export const priceTypeDic: Record<string, any> = {
  "-1": "全部",
  1: "VIP1",
  2: "VIP2",
  3: "VIP3",
  4: "VIP4",
  5: "VIP5",
};
export const goodsBaseStatusList: Record<string, any> = {
  "-2": "全部",
  "-1": "未初始化",
  1: "上架",
  0: "下架",
};
// 拜访账号类型
export const visitAccountTypeList: Record<string, any> = {
  "008": "服务站",
  "009": "业务员",
};
export const traceSourceBaseStatusList: Record<string, any> = {
  "-1": "全部",
  1: "溯源成功",
  0: "溯源失败",
};
//评价状态
export const evaluationType: Record<string, any> = {
  "-1": "全部",
  1: "显示中",
  0: "已隐藏",
};

// 贸易类型
export const tradeTypeList: Record<string, any> = {
  "-1": "全部",
  0: "一般贸易",
  1: "保税贸易",
  //   3: "快件直邮",
};
// 经营模式
export const managingTypeDic: Record<string, any> = {
  "-1": "全部",
  1: "自营",
  2: "代发",
  //   3: "快件直邮",
};
// 导出类型
export const exportTypeList: Record<string, any> = {
  "-1": "全部",
  1: "测试导出",
  2: "",
  3: "",
};
// 导出状态
export const exportStatusList: Record<string, any> = {
  0: "生成中",
  1: "已经生成",
  2: "未生成",
  3: "失败",
};
// 商品等级
export const goodsGrade: Record<string, any> = {
  0: "无",
  1: "S级",
  2: "A级",
  3: "B级",
  4: "C级",
  5: "D级",
  6: "E级",
  7: "F级",
  8: "G级",
  9: "H级",
  10: "I级",
  11: "J级",
  12: "K级",
  13: "L级",
  14: "M级",
  15: "N级",
  16: "O级",
  17: "P级",
  18: "Q级",
  19: "R级",
  20: "T级",
  21: "U级",
  22: "V级",
  23: "W级",
  24: "X级",
  25: "Y级",
  26: "Z级",
};

// 优惠券会员类型
export const memberType: Record<string, any> = {
  1: "全部会员",
  2: "指定会员",
  3: "新注册会员",
};
// 优惠券会员类型
export const couponsendType: Record<string, any> = {
  1: "常规券",
  2: "兑换券",
};
export const memberType1: Record<string, any> = {
  1: "全部会员",
  2: "指定会员",
};
// 门店类型
export const shopType: Record<string, any> = {
  1: "全部门店",
  2: "指定门店参与",
  // 3: "指定门店不参与",
};
export const combineActShopType: Record<string, any> = {
  1: "全部门店",
  2: "指定门店参与",
  3: "指定门店不参与",
};
export const shopType1: Record<string, any> = {
  1: "全部门店",
  2: "指定门店",
  3: "指定范围",
};
export const serviceProviderTypeDic: Record<string, any> = {
  1: "全部服务站",
  2: "指定服务站",
};
export const salesManTypeDic: Record<string, any> = {
  1: "全部业务员",
  2: "指定业务员",
};
// 优惠券发放方式
export const couponSendType: Record<string, any> = {
  1: "注册发放",
  2: "人工注券",
};
// 优惠券状态,  待审核、审核不通过、待开始、发放中、已结束、已作废
export const couponStatus: Record<string, any> = {
  "-2": "全部",
  //   "-1": "强制结束",
  0: "已作废",
  1: "发放中",
  2: "待审核",
  3: "待开始",
  4: "已结束",
  5: "审核不通过",
};
// 礼品券状态,
export const giftCouponStatus: Record<string, any> = {
  "-1": "全部",
  0: "待审核",
  1: "审核不通过",
  2: "待开始",
  3: "发放中",
  4: "已作废",
  5: "已结束",
};
export const giftCouponDistributionType: Record<string, any> = {
  1: "渠道发放",
};
// 优惠券码状态
export const couponCodeStatus: Record<string, any> = {
  "-1": "全部",
  0: "未领取",
  1: "领取",
};
//特价，组合活动状态
export const commbineStatus: Record<string, any> = {
  "-2": "全部",
  //   "-1": "强制结束",
  0: "已作废",
  1: "进行中",
  // 2: "待审核",
  3: "待开始",
  4: "已结束",
  // 5: "审核不通过",
};

// 优惠券类型
export const couponType: Record<string, any> = {
  1: "商品立减券",
  2: "商品折扣券",
};
// 优惠券使用类型
export const couponUseType: Record<string, any> = {
  1: "开始结束时间",
  2: "领取多少天后失效",
};

// 展示角色
export const showRole: Record<string, any> = {
  "-1": "所有角色",
  1: "老板",
  2: "员工",
};
// 员工状态
export const staffStatus: Record<string, any> = {
  "-1": "全部",
  1: "在职",
  0: "离职",
};
// 销售状态
export const sellStatus: Record<string, any> = {
  "-1": "全部",
  1: "允许",
  0: "禁止",
};
// 门店状态
export const shopStatus: Record<string, any> = {
  "-1": "全部",
  0: "禁用",
  1: "开启",
  2: "待审核",
  3: "审核驳回",
  // 4: "待开通",
  5: "开通失败",
};

// 宝宝性别
export const babySex: Record<string, any> = {
  "-1": "全部",
  1: "男",
  2: "女",
};

// 宝宝过敏症状
export const allergicSymptom: Record<string, any> = {
  //   "-1": "全部",
  1: "皮肤症状",
  2: "胃肠道症状",
  3: "呼吸道症状",
  4: "其他",
  5: "还未发生过敏症状",
};

// 退单方式状态
export const returnStatus: Record<string, any> = {
  "-1": "全部",
  0: "仅退款",
  1: "退货退款",
};
// 推送方式状态
export const pushType: Record<string, any> = {
  0: "全部",
  2: "定时推送",
  1: "立即推送",
};
// 消息状态
export const pushStatus: Record<string, any> = {
  "-1": "全部",
  2: "待推送",
  0: "已取消",
  1: "推送成功",
  3: "推送失败",
};

//提现状态
export const withdrawaStatus: Record<string, any> = {
  "-1": "全部",
  0: "待审核",
  1: "审核拒绝",
  2: "打款中",
  3: "打款成功",
  4: "打款失败",
};
export const withdrawaStatus1: Record<string, any> = {
  0: "待审核",
  2: "审核拒绝",
  1: "打款中",
  3: "打款成功",
  4: "打款失败",
};
export const withdrawaStatu2: Record<string, any> = {
  "-1": "待开票",
  0: "待审核",
  1: "审核成功",
  2: "审核拒绝",
  4: "打款成功",
  5: "打款失败",
};
//账号类型
export const accountType: Record<string, any> = {
  "-1": "全部",
  1: "门店",
  2: "员工",
};

//账号类型 - 陈列pk赛账号类型
export const accountTypePK: Record<string, any> = {
  "-1": "全部",
  "003": "门店",
  "004": "员工",
};

//账户类型
export const accountsType: Record<string, any> = {
  "-1": "全部",
  0: "对公账户",
  1: "对私账户",
};

//账户类型1
export const accountsType1: Record<string, any> = {
  //  0: "全部",
  1: "对公账户",
  2: "对私账户",
  3: "法人账户",
};
//活动限制类型
export const actLimitTypes: Record<string, any> = {
  1: "不限制",
  2: "按单限制",
  3: "按听限制",
};

//税金类型
export const taxesTypes: Record<string, any> = {
  2: "活动价",
  1: "原价",
  0: "包税",
};

//活动状态
// export const activityStatus: Record<string, any> = {
//   1: "审核通过",
//   2: "审核拒绝",
//  0: "待审核",
// };
//活动状态
export const activityStatus: Record<string, any> = {
  "-2": "全部",
  //   "-1": "强制结束",
  0: "已作废",
  1: "进行中",
  // 2: "待审核",
  3: "待开始",
  4: "已结束",
  // 5: "审核不通过",
};

//账号类型
export const linkType: Record<string, any> = {
  //   "003": "门店",
  //   "004": "店员",
  //   "005": "连锁",
  门店: "门店",
  店员: "店员",
  推广人: "推广人", //推广人本质上也是 店员，接口没有办法区分，所以用的中文
  连锁: "连锁",
  达人: "达人",
};

//退单方式
export const reType: Record<string, any> = {
  "-1": "全部",
  1: "仅退款",
  2: "退货退款",
};
//退单状态
export const reStatu: Record<string, any> = {
  WAIT_AUDIT: "待审核",
  WAIT_REFUND: "待退款",
  REFUND_ING: "退款中",
  FINISH: "已完成",
  CLOSE: "已关闭",
};

//导出类型
export const importType: Record<string, any> = {
  // 0: "无",
  1: "会员（分佣）订单",
  2: "员工信息",
  3: "会员信息",
  4: "门店信息",
  5: "分佣（分销）商品库存",
  6: "分佣（分销）商品配额",
  7: "优惠券领取",
  8: "商品评价",
  9: "提现订单",
  10: "售后订单",
  11: "对账单",
  12: "B端优惠券",
  13: "服务站",
  14: "分销订单",
  15: "分销异常订单",
  16: "分销退单",
  17: "优惠券码",
  18: "扫码出库",
  19: "素材报表",
  20: "礼品券核销",
  21: "活动报名表",
  22: "陈列PK赛报名表",
  23: "观看课程列表",
  24: "考试列表",
  25: "商品报表明细",
  26: "门店报表明细",
  27: "PDD溯源",
  28: "会员溯源",
  29: "诊疗卡报名明细",
  30: "平台协议",
  31: "业务员",
  32: "门店拜访",
  33: "大区经理",
  34: "补货登记",
  35: "个人收支",
  36: "订单收益",
  37: "充值管理",
  38: "批次信息",
};

//是否使用、是否推送成功,是否风险订单
export const useType: Record<string, any> = {
  //  0: "全部",
  1: "是",
  0: "否",
};
//是否陈列大贸
export const displayD2bGoods: Record<string, any> = {
  "-1": "全部",
  1: "是",
  0: "否",
};
//是否过期
export const outType: Record<string, any> = {
  //  0: "全部",
  1: "过期",
  0: "未过期",
};
// 是否公告
export const isNoticeType: Record<string, any> = {
  //  0: "全部",
  1: "是",
  0: "否",
};

// 配额门店
export const quotaShopType: Record<string, any> = {
  1: "全部门店",
  2: "指定门店",
  3: "指定省份",
};

//对账单状态
export const billStatus: Record<string, any> = {
  CREATE: "待确认",
  WAIT_FINISH: "待完成",
  FINISH: "已完成",
  CANCEL: "已作废",
};

//对账单类型
export const bankType: Record<string, any> = {
  //  0: "全部",
  1: "对公",
  2: "对私",
  3: "对公",
};

//直播状态
export const liveStatus: Record<string, any> = {
  "-2": "全部",
  "-1": "已作废",
  2: "进行中",
  0: "待审核",
  1: "未开始",
  3: "已结束",
};
//直播客户端
export const LiveClient: Record<string, any> = {
  //  0: "全部",
  1: "用户小程序",
  2: "门店小程序",
};
//直播商品状态
export const liveGoodsStatus: Record<string, any> = {
  2: "审核通过",
  0: "未审核",
  1: "审核中",
  3: "审核失败",
};
//商品货源
export const goodsSource: Record<string, any> = {
  // 1: "三方平台",
  2: "渝欧平台",
};
// 分销订单状态 10-关闭，20-待付款，30-待发货，40-已发货，100-已完成,为了循环排序的问题，全部其实是-1，请求的时候在转换下
export const distributeOrderStatusDic: Record<string, any> = {
  1: "全部",
  10: "关闭",
  20: "待付款",
  21: "待上传凭证", //线下付款状态
  22: "凭证待确认", //线下付款状态
  30: "待发货",
  40: "已发货",
  100: "已完成",
};
// 按照顺序来循环
export const distributeOrderStatusArrDic: Record<string, any> = [
  { id: 1, name: "全部" },
  { id: 20, name: "待付款" },
  { id: 21, name: "待上传凭证" },
  { id: 22, name: "凭证待确认" },
  { id: 30, name: "待发货" },
  { id: 40, name: "已发货" },
  { id: 100, name: "已完成" },
  { id: 10, name: "关闭" },
];

// 分销订单状态 10-关闭，20-待付款，30-待发货，40-已发货，100-已完成,为了循环排序的问题，全部其实是-1，请求的时候在转换下
export const retailOrderStatusDic: Record<string, any> = {
  1: "全部",
  10: "关闭",
  20: "待付款",
  23: "待会员确认",
  30: "待发货",
  40: "已发货",
  100: "已完成",
};

export const orderListDic: Record<string, any> = {
  1: "全部",
  14: "已发货",
  15: "已完成",
};

export const retailOrderListStatusDic: Record<string, any> = {
  1: "全部",
  10: "关闭",
  20: "待付款",
  23: "待会员确认",
  30: "待发货",
  40: "已发货",
  100: "已完成",
};

// 根角色列表枚举（用于获取登录角色列表和当前登录角色）
export const rootRoleListDic: Record<string, any> = {
  "001": {
    name: "admin",
  },
  "002": {
    name: "supplier",
  },
  "008": {
    name: "service",
  },
};
// 售后订单状态
export const afterSaleStatusDic: Record<string, any> = {
  1: "全部",
  10: "待审核",
  20: "待退款",
  30: "退款中",
  40: "已完成",
  50: "已关闭",
  60: "待退货",
};
// 发票审核状态
export const invoiceStatusDic: Record<string, any> = {
  "-1": "全部",
  1: "待审核",
  2: "开票成功",
  3: "开票失败",
};
// 发票类型
export const invoiceTypeDic: Record<string, any> = {
  "-1": "全部",
  1: "普票",
  2: "专票",
};
// 支付方式
export const paymentTypeDic: Record<string, any> = {
  "-1": "全部",
  1: "线下支付",
  2: "服务站支付",
  3: "中金支付（商品云）",
  4: "模拟支付",
  5: "支付宝",
  6: "微信",
  7: "快捷支付",
};
// 扫码人类型
export const scanCodePersonType: Record<string, any> = {
  "-1": "全部",
  "003": "门店",
  "004": "店员",
};
// 礼品券核销
export const gitCouponVerificationStatusDic: Record<string, any> = {
  "-1": "全部",
  "0": "待核销",
  "1": "已核销",
  "2": "已失效",
};

export const shopStatusDic: Record<string, any> = {
  "0": "禁用",
  "1": "启用",
  "2": "待审核",
  "3": "审核拒绝",
  "4": "待开通",
  "5": "开通失败",
  "6": "已注销",
};

// 礼品券核销发货
export const gitCouponSendGoodsStatusDic: Record<string, any> = {
  "0": "待发货",
  "1": "已完成",
  "2": "已关闭",
};
// 链接小工具类型
export const linkSmallToolsDic: Record<string, any> = {
  "1": "超链接",
  "3": "素材链接",
  "4": "消息链接",
  "5": "商品链接",
  "6": "小程序链接",
  "7": "商品组",
};
//核销方式
export const writeOffType: Record<string, any> = {
  1: "平台",
  2: "门店",
};
//礼品券状态
export const voucherStatus: Record<string, any> = {
  0: "待审核",
  1: "审核不通过",
  2: "待开始",
  3: "发放中",
  4: "已作废",
  5: "已结束",
};
//扫码激励状态
export const rewardStatus: Record<string, any> = {
  0: "已作废",
  1: "进行中",
  2: "已结束",
  3: "待开始",
};
//组合活动状态
export const combineActStatus: Record<string, any> = {
  "-1": "强制结束",
  0: "已作废",
  1: "进行中",
  3: "待开始",
  4: "已结束",
};
//大区列表
export const regionDic: Record<string, any> = {
  "01": "东一区",
  "02": "东二区",
  "03": "东三区",
  "04": "南一区",
  "05": "南二区",
  "06": "北区",
  "07": "中区",
  "08": "西区",
};
//风险订单规则
export const riskOrderStatusDic: Record<string, any> = {
  "-1": "全部",
  //   0: "待判定",
  1: "正常订单",
  2: "风险订单待审核",
  3: "风险订单审核通过",
  4: "风险订单审核驳回",
};

//门店明细状态
export const shopDetailStatusDic: Record<string, any> = {
  0: "全部",
  1: "待审核",
  2: "审核通过",
  3: "审核不通过",
};

export const shopTypeList: Record<string, any> = {
  1: "总店",
  2: "分店",
  3: "单体门店",
};
//门店注册列表
export const shopRegTypeList: Record<string, any> = {
  Shop: "门店",
  Personal: "达人",
};

export const shopClassifyDic: Record<string, any> = {
  1: "MMT",
  2: "RKA",
};

// 采购权限
export const procureStatus: Record<string, any> = {
  1: "开启",
  0: "关闭",
};

//诊疗卡类型
export const diagnosticStatus: Record<string, any> = {
  1: "牛奶蛋白过敏鉴别诊断疗程卡",
  2: "重度过敏疗程卡",
  3: "轻中度过敏疗程卡",
  4: "1岁以上过敏孩子生长追赶疗程卡",
  5: "成长初级疗程卡",
  6: "成长标准疗程卡",
  7: "成长进阶疗程卡",
};
//剩余库存
export const remainStockDic: Record<string, any> = {
  "-1": "全部",
  1: "售罄",
  2: "告急",
  3: "充足",
};

//活动管理-任务管理  活动状态,ALL:全部, AUDIT_WAIT:待审核, AUDIT_REJECT:审核不通过, READY_START:待开始, ON_GOING:进行中, ENDED:已结束, ABANDON:已作废,可用
export const activityManaTaskManaListStatusDic: Record<string, any> = {
  ALL: "全部",
  AUDIT_WAIT: "待审核",
  AUDIT_REJECT: "审核不通过",
  READY_START: "待开始",
  ON_GOING: "进行中",
  ENDED: "已结束",
  ABANDON: "已作废",
};

export const activityManaTaskManaListTypeDic: Record<string, any> = {
  ALL: "全部",
  SHOP_EXHIBIT: "陈列打卡",
  SHOP_PAYMENT: "付费专区",
  BRAND_ADVERTISING: "品宣打卡",
};
// 报名审核状态,AUDIT_REJECT:报名驳回, AUDIT_WAIT:待验证, AUDIT_PASS:待发货, UPLOAD_IMG_WAIT:待打卡, UPLOAD_IMG_AUDIT_WAIT:待审核, UPLOAD_IMG_AUDIT_REJECT:打卡驳回, UPLOAD_IMG_AUDIT_PASS:已完成,可用值:AUDIT_REJECT,AUDIT_WAIT,AUDIT_PASS,UPLOAD_IMG_WAIT,UPLOAD_IMG_AUDIT_WAIT,UPLOAD_IMG_AUDIT_REJECT,UPLOAD_IMG_AUDIT_PASS
export const activityManaTaskManaApplicationListStatusDic: Record<string, any> =
  {
    ALL: "全部",
    AUDIT_REJECT: "报名驳回",
    AUDIT_WAIT: "待验证",
    AUDIT_PASS: "待发货",
    UPLOAD_IMG_WAIT: "待打卡",
    UPLOAD_IMG_AUDIT_WAIT: "待审核",
    UPLOAD_IMG_AUDIT_REJECT: "打卡驳回",
    UPLOAD_IMG_AUDIT_PASS: "已完成",
    ABANDON: "已作废",
    TASK_EXPIRED: "任务过期",
  };

export const numToText: Record<string, any> = {
  1: "一",
  2: "二",
  3: "三",
  4: "四",
  5: "五",
  6: "六",
  7: "七",
  8: "八",
  9: "九",
  10: "十",
};

export const callLogStatusDic: Record<string, any> = {
  dealing: "已接",
  notDeal: "振铃未接听",
  leak: "ivr放弃",
  queueLeak: "排队放弃",
  blackList: "黑名单",
  voicemail: "留言",
  limit: "并发限制",
  failed: "失败",
};

export const inventoryStatusDic: Record<string, any> = {
  "-1": "全部",
  1: "售罄",
  2: "告急",
  3: "充足",
};
export const shopConveyStatus: Record<string, any> = {
  //   "-2": "全部",
  "-1": "传输失败",
  0: "未传输",
  1: "已传输",
};

export const AIMaterialShowStatus: Record<string, any> = {
  ALL: "全部",
  SHOW: "展示中",
  HIDDEN: "已删除",
};

export const AIMaterialStatus: Record<string, any> = {
  ALL: "全部",
  WAIT: "待生成",
  PROCESSING: "生成中",
  DONE: "生成成功",
  FAIL: "生成失败",
};

export const virtualMaterialStatus: Record<string, any> = {
  ALL: "全部",
  AUDIT_WAIT: "待审核",
  AUDIT_PASS: "审核通过",
  AUDIT_REJECT: "审核拒绝",
};

export const materialType: Record<string, any> = {
  ALL: "全部",
  IMAGE: "普通素材",
  VIDEO: "AI素材",
};
